import { registerBlockType } from '@wordpress/blocks';
import Edit from './edit';
import metadata from './block.json';

import './index.css';

const titleIcon = (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M2.40625 16.6016C2.58854 16.0286 2.88802 15.5469 3.30469 15.1562L15.1797 3.24219C15.6745 2.77344 16.2604 2.53906 16.9375 2.53906C17.6146 2.53906 18.2005 2.77344 18.6953 3.24219L20.2578 4.80469C20.362 4.90885 20.4661 5.03906 20.5703 5.19531C20.8828 5.6901 21.013 6.22396 20.9609 6.79688C20.9089 7.36979 20.6745 7.8776 20.2578 8.32031L8.38281 20.1953C8.35677 20.2214 8.33073 20.2474 8.30469 20.2734C8.27865 20.2734 8.2526 20.2995 8.22656 20.3516C7.83594 20.6641 7.39323 20.9115 6.89844 21.0938L2.21094 22.4609C1.84635 22.5651 1.53385 22.474 1.27344 22.1875C1.01302 21.9531 0.934896 21.6536 1.03906 21.2891L2.40625 16.6016ZM3.30469 20.1953L6.39062 19.2969C6.625 19.2188 6.84635 19.0885 7.05469 18.9062L15.9609 9.96094L13.5 7.5L4.63281 16.4453C4.60677 16.4714 4.58073 16.4974 4.55469 16.5234C4.39844 16.7057 4.28125 16.901 4.20312 17.1094L3.30469 20.1953ZM22.5625 20.625C23.1354 20.6771 23.4479 20.9896 23.5 21.5625C23.4479 22.1354 23.1354 22.4479 22.5625 22.5H10.6875C10.1146 22.4479 9.80208 22.1354 9.75 21.5625C9.80208 20.9896 10.1146 20.6771 10.6875 20.625H22.5625Z"
            fill="#1A62FF"
        />
    </svg>
);

registerBlockType(metadata.name, {
    icon: titleIcon,
    title: metadata.title,
    edit: Edit,
});
